import { render, staticRenderFns } from "./information.vue?vue&type=template&id=a97b6420&scoped=true"
import script from "./information.vue?vue&type=script&lang=ts"
export * from "./information.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97b6420",
  null
  
)

export default component.exports